<ad-item-tag>
<div class="container_project-info margin-spacing-1_bottom">
<span class="status_label status_label-entry margin-spacing-1_right" if={props.room.entry_id}></span>

<ul class="information_list">
	<li class="information_list-item "><span class="information_list-item-title">公募広告ID:</span>{props.room.ad_id}</li>
</ul><!--/.information_list-->
	
	<!-- <div class="btn_favorite js-toggle_switch"></div>-->
</div><!--/.container_project-info-->
<h2 class="matter_heading margin-spacing-2_bottom"><a href="{`/ad/detail/${props.room.ad_id}`}">{props.room.ad_title}</a></h2>
<div class="container_schedule-info">
	<div class="button button-secondary-mini"><a href="{`/chat/room/${props.room.id}`}">チャットルームへ</a></div>
</div><!--/.container_schedule-info-->

</ad-item-tag>
